module.exports = __webpack_public_path__ + "static/media/gallery-3-4.6db6bd19.png";